<nav id="skipNav" class="skipNav" role="navigation" aria-label="">
  <ul>
    <li class="skiplink" role="presentation">
      <a href="javascript:void(0);" tabindex="0" title="HotKey" accesskey="1" role="menuitem" (click)="skipToContent();">{{'wifiSkip' | translate}}</a>
    </li>
  </ul>
</nav>